<template>
	<div class="abpage" :style="{'width':width,'height':height}">
		<slot></slot>
	</div>
</template>


<style scoped>
	.abpage {
		position: absolute;
		left: 50%;
		top: 50%;
		-webkit-transform: translate(-50%, -50%);
	}
</style>


<script>
	export default {
		props: {

		},
		data() {
			return {

			};
		},
		mounted() {
			window.addEventListener("resize", function() {
				this.init()
			}.bind(this), false)
		},
		computed: {
			width: {
				get: function() {
					return Math.min(document.documentElement.clientWidth, this.$store.state.maxWidth) + 'px'
				},
				set: function() {}
			},
			height: {
				get: function() {
					return Math.min(document.documentElement.clientHeight, this.$store.state.maxHeight) + 'px'
				},
				set: function() {}
			},
		},
		watch: {

		},
		methods: {
			init() {
				this.width = document.documentElement.clientWidth + 'px'
				this.height = document.documentElement.clientHeight + 'px'
			}

		},

	}
</script>
